import { uniqWith, isEqual, includes } from 'lodash';

export const SET_ACTIVE_VIEW_ID = 'flashMessages/setActiveViewId';
export const SHOW = 'flashMessages/show';
export const SHOW_SUCCESS = 'flashMessages/showSuccess';
export const SHOW_GENERAL = 'flashMessages/showGeneral';
export const SHOW_FAILURE = 'flashMessages/showFailure';
export const RESET_VIEW = 'flashMessages/resetView';
export const RESET = 'flashMessages/reset';
export const RESET_ONLY = 'flashMessages/resetOnly';

export const SUCCESS = 'success';
export const GENERAL = 'general';
export const FAILURE = 'failure';

export const INITIAL_STATE = {
  indicators: [],
  activeViewId: '',
};

let reduxStore = null;

export function setReduxStore(store) {
  reduxStore = store;
}

export function setActiveViewId(id) {
  return { type: SET_ACTIVE_VIEW_ID, payload: { id } };
}

export function showFlash(message, validViews) {
  return { type: SHOW, payload: { what: { message, validViews } } };
}

export function showSuccessFlash(message, validViews) {
  return {
    type: SHOW_SUCCESS,
    payload: { what: { message: `${message}.${SUCCESS}`, validViews } },
  };
}

export function showGeneralFlash(message, validViews) {
  return {
    type: SHOW_GENERAL,
    payload: { what: { message: `${message}.${GENERAL}`, validViews } },
  };
}

export function showFailureFlash(message, validViews) {
  return {
    type: SHOW_FAILURE,
    payload: { what: { message: `${message}.${FAILURE}`, validViews } },
  };
}

export function resetFlashView({ from } = {}) {
  return { type: RESET_VIEW, payload: { from } };
}

export function resetFlash({ from, viewId } = {}) {
  return { type: RESET, payload: { from, viewId } };
}

export function resetOnlyFlash(whats) {
  return { type: RESET_ONLY, payload: { whats } };
}

export function isFlashVisible(store = reduxStore.getState()) {
  return what => store.flashMessages.indicators.some(({ message }) => message === what);
}

export function addIndicatorToState(state, what) {
  return {
    ...state,
    indicators: uniqWith([...state.indicators, what], isEqual),
  };
}

export function filterOutCurrentViewFlashes(state, viewId) {
  return state.indicators.filter(
    ({ validViews }) => !includes(validViews, viewId || state.activeViewId),
  );
}

export default function FlashMessagesStateManager(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case SET_ACTIVE_VIEW_ID:
      return {
        ...state,
        activeViewId: payload.id,
      };
    case SHOW:
    case SHOW_GENERAL:
    case SHOW_SUCCESS:
    case SHOW_FAILURE:
      return addIndicatorToState(state, payload.what);
    case RESET_VIEW:
      return {
        ...INITIAL_STATE,
        indicators: filterOutCurrentViewFlashes(state),
      };
    case RESET:
      return {
        ...state,
        indicators: filterOutCurrentViewFlashes(state, payload.viewId),
      };
    case RESET_ONLY:
      return {
        ...state,
        indicators: state.indicators.filter(({ message }) => !includes(payload.whats, message)),
      };
    default:
      return state;
  }
}
